<button
  [type]="type"
  [disabled]="disabled || loading"
  [class]="buttonClasses"
  [ngStyle]="customStyles"
  (click)="onClick($event)"
>
  <!-- Loading spinner -->
  <span *ngIf="loading" class="btn-spinner">
    <svg class="spinner" viewBox="0 0 24 24">
      <circle
        class="spinner-circle"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        stroke-width="2"
        fill="none"
        stroke-linecap="round"
        stroke-dasharray="32"
        stroke-dashoffset="32"
      >
        <animate
          attributeName="stroke-dasharray"
          dur="2s"
          values="0 32;16 16;0 32;0 32"
          repeatCount="indefinite"
        />
        <animate
          attributeName="stroke-dashoffset"
          dur="2s"
          values="0;-16;-32;-32"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  </span>

  <!-- Icon izquierda -->
  <span
    *ngIf="icon && iconPosition === 'left' && !loading"
    class="btn-icon btn-icon-left"
    [innerHTML]="icon"
  >
  </span>

  <!-- Texto del botón -->
  <span *ngIf="text" class="btn-text inter">{{ text }}</span>

  <!-- Icon derecha -->
  <span
    *ngIf="icon && iconPosition === 'right' && !loading"
    class="btn-icon btn-icon-right"
    [innerHTML]="icon"
  >
  </span>

  <!-- Contenido proyectado (ng-content) -->
  <ng-content></ng-content>
</button>
